// import { configureStore } from '@reduxjs/toolkit';
// import { combineReducers } from 'redux';
// import { persistStore, persistReducer, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import userReducer from './userSlice';

// const rootReducer = combineReducers({
//   user: userReducer,
// });

// const persistConfig = {
//   key: 'root',
//   storage,
//   whitelist: ['user'],
//   // **ADD THIS: Helps with debugging**
//   debug: true,
// };

// const persistedReducer = persistReducer(persistConfig, rootReducer);

// export const store = configureStore({
//   reducer: persistedReducer,
//   middleware: (getDefaultMiddleware) =>
//     getDefaultMiddleware({
//       serializableCheck: {
//         ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
//       },
//     }),
// });

// export const persistor = persistStore(store);

// // **ADD THIS: Optional - Add a function to manually purge**
// export const purgePersistor = async () => {
//   await persistor.purge();
//   await persistor.flush();
// };

import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
  createMigrate
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userReducer from './userSlice';

const rootReducer = combineReducers({
  user: userReducer,
});

// ✅ CRITICAL: Custom state reconciler that checks browser session
const customStateReconciler = (inboundState, originalState, reducedState, config) => {
  const browserSession = sessionStorage.getItem('browser_session_active');
  
  console.log('🔄 State reconciler called:', {
    hasBrowserSession: !!browserSession,
    hasInboundState: !!inboundState
  });

  // ✅ If no browser session, return clean state (ignore persisted state)
  if (!browserSession) {
    console.log('⚠️ No browser session - returning clean state');
    return originalState;
  }

  // ✅ If browser session exists, use persisted state
  console.log('✅ Browser session exists - using persisted state');
  return inboundState;
};

// ✅ Migration to handle state validation
const migrations = {
  6: (state) => {
    console.log('🔄 Running migration v6...');
    
    const browserSession = sessionStorage.getItem('browser_session_active');
    const token = localStorage.getItem('auth_token');
    const userId = localStorage.getItem('user_id');

    // ✅ If no browser session, return clean state
    if (!browserSession) {
      console.log('⚠️ No browser session during migration - returning clean state');
      
      // Clean up localStorage
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user_id');
      localStorage.removeItem('user_email');
      localStorage.removeItem('user_name');
      
      return {
        user: {
          user: null,
          isAuthenticated: false,
          properties: [],
          subscription: {
            plan: 'free',
            propertiesAdded: 3,
            maxProperties: 999,
            coolingPeriod: null,
            listingDuration: null,
          },
          messaging: {
            currentConversationId: null,
            conversations: [],
            senderId: null,
            receiverId: null
          },
          formData: {
            login: { email: '', username: '', phone: '' },
            register: {
              fullName: '', email: '', username: '', contactNumber: '',
              address: '', city: '', state: '', zipCode: '', country: '',
              agreedToTerms: false
            }
          },
          userProfile: { fullName: '', email: '', contactNumber: '' }
        }
      };
    }

    // ✅ If no token or userId, return clean state
    if (!token || !userId) {
      console.log('⚠️ No valid auth found during migration - returning clean state');
      return {
        user: {
          user: null,
          isAuthenticated: false,
          properties: [],
          subscription: {
            plan: 'free',
            propertiesAdded: 3,
            maxProperties: 999,
            coolingPeriod: null,
            listingDuration: null,
          },
          messaging: {
            currentConversationId: null,
            conversations: [],
            senderId: null,
            receiverId: null
          },
          formData: {
            login: { email: '', username: '', phone: '' },
            register: {
              fullName: '', email: '', username: '', contactNumber: '',
              address: '', city: '', state: '', zipCode: '', country: '',
              agreedToTerms: false
            }
          },
          userProfile: { fullName: '', email: '', contactNumber: '' }
        }
      };
    }

    console.log('✅ Valid auth and browser session - keeping state');
    return state;
  }
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['user'],
  debug: true,
  version: 6, // ✅ Updated version to 6
  migrate: createMigrate(migrations, { debug: true }),
  stateReconciler: customStateReconciler, // ✅ CRITICAL: Use custom reconciler
  timeout: 10000,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
});

export const persistor = persistStore(store);

// ✅ Enhanced purge function
export const purgePersistor = async () => {
  try {
    console.log('🧹 Purging persistor...');
    await persistor.purge();
    await persistor.flush();
    localStorage.removeItem('persist:root');
    console.log('✅ Persistor purged successfully');
  } catch (error) {
    console.error('❌ Error purging persistor:', error);
  }
};